import { takeEvery, put, call } from "redux-saga/effects";
// Calender Redux States
import {
  STAFF_PART_DETAILS,
  SERVICE_ITEM_DETAILS,
  POST_CLOCK_IN_TIME,
  STAFF_GET_EVENTS,
  SERVICE_PROGRESS_NOTE,
  STAFF_TASK_ID,
  // POST_TASK_DOC,
  // GET_STAFF_DOC,
  LOGOUT_STAFF,
  GET_NOTE_BY_ID,
  UPDATE_STAFF_PRO_NOTE,
  POST_TIMMINGS,
  STAFF_ACTION,
  SUBMIT_INICIDENT_REPORT,
  SET_TASK_TIMEOUT,
  SUBMITION_APPROVAL,
  NOTES_BY_ADMIN,
  GET_EMPLOYEE_PROFILE_DETAILS,
  SEND_ATTACHMENTS_BY_EMPLOYEE,
  UPLOAD_REQ_DOCS,
  UPLOAD_STAFF_CERTIFICATE_DOCS,
  GET_DOCUMENTS_STATUS_LIST,
  GET_TRAININGS_STAFF,
  GET_INICIDENT_FORM_QUESTIONS,
  SUBMIT_INCIDENT_FORM_EMPLOYEE,
  GET_POLICY_FOR_EMPLOYEE,
  CONFIRM_TRAINING_TERMS,
  HIT_DOWNLOAD,
  GET_MY_SHIFTS,
  EMP_GET_FOLDERS,
  EMP_GET_FOLDER_FILES,
  EMP_ADD_FILE_TO_FOLDER,
  START_EMP_SHIFT,
  END_EMP_SHIFT,
  EMP_AVAILABILITY,
  EMP_ADD_AVAILABILITY,
  EMP_GET_OPEN_SHIFTS,
  REQUEST_OPEN_SHIFT,
  CANCEL_OPEN_SHIFT,
  GET_REQUESTED_OPEN_SHIFTS,
  USER_ACCOUNTS_LIST,
  SWITCH_ACCOUNT,
  REMOVE_EMP_SWITCH_ACCOUNT,
  GET_MEDICATION_DETAILS,
  SUBMIT_MED_REPORT,
  GET_EMP_MEDICINE_LIST,
  GET_TODAYS_MEDICATION,
  EMP_SUBMIT_MEDICATION,
  EMP_MEDICATION_PRN,
  SUBMIT_HAZARD_REPORT,
  SAVE_PROGRESS_NOTE,
  REFINE_TEXT,
  GET_SUPPORT_WORKER_TIME_SHEETS,
  SUBMIT_TIMESHEET_COMMENT,
  AWAY_PARTICIPANT,
  UPDATE_VEHICLE_DETAILS_EMPLOYEE,
  SUBMIT_EMPLOYEE_COMPLAINT_FORM,
  EMP_UPDATE_AVAILABILITY,
} from "./actionTypes";
import {
  staffgetEventsSuccess,
  staffgetEventsFail,
  getPartDetailFail,
  getPartDetailSuccess,
  serviceProgressNoteSuccess,
  serviceProgressNoteFail,
  getServiceItemDetailsSuccess,
  getServiceItemDetailsFail,
  postClockInTimeFail,
  postClockInTimeSuccess,
  staffTaskidSuccess,
  staffTaskidFail,
  // postTaskDocFail,
  // postTaskDocSuccess,
  // getStaffDocFail,
  // getStaffDocSuccess,
  logout_staffSuccess,
  logout_staffFail,
  getNoteByIdFail,
  getNoteByIdSuccess,
  updateStaffNoteFail,
  updateStaffNoteSuccess,
  postTimmingsSuccess,
  postTimmingsFail,
  staffActionSuccess,
  staffActionFail,
  submitIncidentReportSuccess,
  submitIncidentReportFail,
  setTaskTimeoutFail,
  setTaskTimeoutSuccess,
  showModal,
  submitApproveSuccess,
  submitApproveFail,
  notesByAdminSuccess,
  notesByAdminFail,
  getEmployeeProfileSuccess,
  getEmployeeProfileFail,
  sendAttachmentsByEmployeeFail,
  sendAttachmentsByEmployeeSuccess,
  uploadReqDocsSuccess,
  uploadReqDocsFail,
  uploadTrainingCertDocsFail,
  uploadTrainingCertDocsSuccess,
  documentsStatusFail,
  documentsStatusSuccess,
  getEmployeeTrainingsFail,
  getEmployeeTrainingsSuccess,
  getIncidentFormQuestionSuccess,
  getIncidentFormQuestionFail,
  submitEmployeeIncidentFormSuccess,
  submitEmployeeIncidentFormFail,
  getPolicyForEmployeeFail,
  getPolicyForEmployeeSuccess,
  hitDownloadSuccess,
  hitDownloadFail,
  getMyShiftsSuccess,
  getMyShiftsFail,
  empGetFoldersSuccess,
  empGetFoldersFail,
  empGetFoldersFileSuccess,
  empGetFoldersFileFail,
  empAddFileToFolder,
  empAddFileToFolderFail,
  empAddFileToFolderSuccess,
  startEmpShiftSuccess,
  startEmpShiftFail,
  endEmpShiftSuccess,
  endEmpShiftFail,
  getEmpAvailabilitySuccess,
  getEmpAvailabilityFail,
  addEmpAvailabilitySuccess,
  addEmpAvailabilityFail,
  empGetOpenShiftSuccess,
  empGetOpenShiftFail,
  requestOpenShiftSuccess,
  requestOpenShiftFail,
  cancelOpenShiftSuccess,
  cancelOpenShiftFail,
  getRequestedOpenShiftsSuccess,
  getRequestedOpenShiftsFail,
  empGetOpenShift,
  getRequestedOpenShifts,
  accountsListSuccess,
  accountsListFail,
  switchAccountSuccess,
  switchAccountFail,
  removeEmpSwitchAccSuccess,
  removeEmpSwitchAccFail,
  getEmpMedicationDetailsSuccess,
  getEmpMedicationDetailsFail,
  submitMedReportSuccess,
  submitMedReportFail,
  getEmpMedicinesSuccess,
  getEmpMedicinesFail,
  getTodaysMedicationsSuccess,
  getTodaysMedicationsFail,
  empSubmitMedicationSuccess,
  empSubmitMedicationFail,
  empMedicationPrnSuccess,
  empMedicationPrnFail,
  submitHazardReportSuccess,
  submitHazardReportFail,
  saveProgressNoteByUserFail,
  saveProgressNoteByUserSuccess,
  refineNotesTextSuccess,
  refineNotesTextFail,
  getSupportWorkerTimeSheetSuccess,
  getSupportWorkerTimeSheetFail,
  submitTimeSheetCommentSuccess,
  submitTimeSheetCommentFail,
  awayPariticipantSuccess,
  awayPariticipantError,
  updateVehicleDetailsSuccess,
  updateVehicleDetailsFail,
  getEmployeeComplaintFormSuccess,
  getEmployeeComplaintFormError,
  updateEmpAvailability,
  updateEmpAvailabilitySuccess,
  updateEmpAvailabilityFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  staffgetEvents,
  partDetailsgetStaff,
  getProgNotes,
  getSerItem,
  postClockintime,
  staffTaskDetailsid,
  // postTaskDocuments,
  // getStaffDocslist,
  log_out_staff,
  getProgressNotes,
  updateStaffProgressNote,
  postTimmingData,
  onConfirmingJob,
  postIncidentReport,
  setTaskTimeoutouted,
  approveSubmit,
  progressNotesByAdmin,
  employeeProfile,
  sendAttachedFileByEmployee,
  uploadEmployeeReqDocs,
  uploadStaffCert,
  getDocumentsStatus,
  getStaffTraining,
  incidentFormQuestions,
  submitIncidentForm,
  fetchPoliyForEmployee,
  trainingTermsConfirmation,
  clickedOnDownlaod,
  fetchMyShifts,
  onEmpAddingFileToFolder,
  onEmpFecthFiles,
  onEmpFecthFolders,
  onEmpStartingShift,
  onEmpEndingShift,
  onEmpGetingAvailability,
  onEmpAddingAvailability,
  onEmpGetingOpenShift,
  onRequestingOpenShift,
  onCancelingOpenShift,
  onGettingRequestedOpenShift,
  onGettingAccountList,
  onSwitchingAccount,
  onRemovingSwitchAccount,
  onGettingEmpMedication,
  onSubmittingMedReport,
  onGettingEmpMedicines,
  onGettingTodaysMedications,
  onSubmittingMedication,
  onGettingMedPRN,
  onSubmittingHazard,
  onSavingNoteByUser,
  onRefiningNotesText,
  onGettingSupportWorkerTimeSheet,
  onSubmittingComment,
  onSubmittingComplaintList,
  awayPariticipant,
  onUpdatingVehicleDetails,
  onEmpUpdatingAvailability,
} from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { confirmTrainingTermsFail, confirmTrainingTermsSuccess, updateEmployeeFail } from "store/actions";
import { responseHandler } from "common/CommanFunction";

function* onGetMedPRN({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingMedPRN, data);
    yield call(responseHandler, "Medication", response, empMedicationPrnSuccess, empMedicationPrnFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(empMedicationPrnFail(error));
    showToast("error", "Medication", error);
  }
}

function* onRefineNotesText({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRefiningNotesText, data);
    yield call(responseHandler, "Progress Note", response, refineNotesTextSuccess, refineNotesTextFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(refineNotesTextFail(error));
    showToast("error", "Progress Note", error);
  }
}

function* onSubmitHazard({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSubmittingHazard, data);
    yield call(responseHandler, "Hazard Report", response, submitHazardReportSuccess, submitHazardReportFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(submitHazardReportFail(error));
    showToast("error", "Hazard Report", error);
  }
}

function* onSubmitMedication({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSubmittingMedication, data);
    yield call(responseHandler, "Medication", response, empSubmitMedicationSuccess, empSubmitMedicationFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(empSubmitMedicationFail(error));
    showToast("error", "Medication", error);
  }
}

function* onGetTodaysMedications({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTodaysMedications, data);
    yield call(responseHandler, "Today's Medication", response, getTodaysMedicationsSuccess, getTodaysMedicationsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getTodaysMedicationsFail(error));
    showToast("error", "Today's Medication", error);
  }
}

function* onGetEmpMedicines({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingEmpMedicines, data);
    yield call(responseHandler, "Medication", response, getEmpMedicinesSuccess, getEmpMedicinesFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getEmpMedicinesFail(error));
    showToast("error", "Medication", error);
  }
}

function* onSubmitMedReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSubmittingMedReport, data);
    yield call(responseHandler, "Medication", response, submitMedReportSuccess, submitMedReportFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(submitMedReportFail(error));
    showToast("error", "Medication", error);
  }
}

function* onGetMedication({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingEmpMedication, data);
    yield call(responseHandler, "Medication", response, getEmpMedicationDetailsSuccess, getEmpMedicationDetailsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getEmpMedicationDetailsFail(error));
    showToast("error", "Medication", error);
  }
}

function* onRemoveSwitchAccount({ payload: { data, onSuccess, onError, header } }) {
  try {
    const response = yield call(onRemovingSwitchAccount, data, header);
    yield call(responseHandler, "Switching Account", response, removeEmpSwitchAccSuccess, removeEmpSwitchAccFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(removeEmpSwitchAccFail(error));
    showToast("error", "Switching Account", error);
  }
}

function* onSwitchAccount({ payload: { data, onSuccess, onError, header } }) {
  try {
    const response = yield call(onSwitchingAccount, data, header);
    yield call(responseHandler, "Switching Account", response, switchAccountSuccess, switchAccountFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(switchAccountFail(error));
    showToast("error", "Switching Account", error);
  }
}

function* onGetAccountList({ payload: { data, onSuccess, onError, header } }) {
  try {
    const response = yield call(onGettingAccountList, data, header);
    yield call(responseHandler, "Account List", response, accountsListSuccess, accountsListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(accountsListFail(error));
    showToast("error", "Account List", error);
  }
}

function* onRequestOpenShift({ payload: { data, dispatch } }) {
  try {
    const response = yield call(onRequestingOpenShift, data);
    if (response.status) {
      yield put(requestOpenShiftSuccess(response));
      showToast("success", "Requesting Shift", response.message);
      dispatch(empGetOpenShift());
    } else {
      yield put(requestOpenShiftFail(response));
      showToast("warning", "Requesting Shift", response.message);
    }
  } catch (error) {
    yield put(requestOpenShiftFail(error));
    showToast("error", "Requesting Shift", error);
  }
}

function* onCancelOpenShift({ payload: { data, dispatch } }) {
  try {
    const response = yield call(onCancelingOpenShift, data);
    if (response.status) {
      yield put(cancelOpenShiftSuccess(response));
      showToast("success", "Withdraw", response.message);
      dispatch(getRequestedOpenShifts());
    } else {
      yield put(cancelOpenShiftFail(response));
      showToast("warning", "Withdraw", response.message);
    }
  } catch (error) {
    yield put(cancelOpenShiftFail(error));
    showToast("error", "Withdraw", error);
  }
}

function* onGetRequestedOpenShift({ payload: data }) {
  try {
    const response = yield call(onGettingRequestedOpenShift, data);
    if (response.status) {
      yield put(getRequestedOpenShiftsSuccess(response));
    } else {
      yield put(getRequestedOpenShiftsFail(response));
      showToast("warning", "Requested Shift", response.message);
    }
  } catch (error) {
    yield put(getRequestedOpenShiftsFail(error));
    showToast("error", "Requested Shift", error);
  }
}

function* onEmpGetAvailability({ payload: data }) {
  try {
    const response = yield call(onEmpGetingAvailability, data);
    if (response.status) {
      yield put(getEmpAvailabilitySuccess(response));
    } else {
      yield put(getEmpAvailabilityFail(response));
      showToast("warning", "Availability", response.message);
    }
  } catch (error) {
    yield put(getEmpAvailabilityFail(error));
    showToast("error", "Availability", error);
  }
}

function* onGettingOpenShift({ payload: data }) {
  try {
    const response = yield call(onEmpGetingOpenShift, data);
    if (response.status) {
      yield put(empGetOpenShiftSuccess(response));
    } else {
      yield put(empGetOpenShiftFail(response));
      showToast("warning", "Open Shift", response.message);
    }
  } catch (error) {
    yield put(empGetOpenShiftFail(error));
    showToast("error", "Open Shift", error);
  }
}

function* onEmpAddOpenShift({ payload: data }) {
  try {
    const response = yield call(onEmpAddingAvailability, data);
    if (response.status) {
      yield put(addEmpAvailabilitySuccess(response));
      showToast("success", "Availability", response.message);
    } else {
      yield put(addEmpAvailabilityFail(response));
      showToast("warning", "Availability", response.message);
    }
  } catch (error) {
    yield put(addEmpAvailabilityFail(error));
    showToast("error", "Availability", error);
  }
}

function* onEmpUpdateOpenShift({ payload: data }) {
  try {
    const response = yield call(onEmpUpdatingAvailability, data);
    if (response.status) {
      yield put(updateEmpAvailabilitySuccess(response));
      showToast("success", "Update Availability", response.message);
    } else {
      yield put(updateEmpAvailabilityFail(response));
      showToast("warning", "Nothing Update", response.message);
    }
  } catch (error) {
    yield put(updateEmpAvailabilityFail(error));
    showToast("error", "Availability", error);
  }
}
function* onEmpEndShift({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onEmpEndingShift, data);
    yield call(responseHandler, "Shift End", response, endEmpShiftSuccess, endEmpShiftFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(endEmpShiftFail(error));
    showToast("error", "Shift", error);
  }
}

function* onEmpStartShift({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onEmpStartingShift, data);
    yield call(responseHandler, "Shift Start", response, startEmpShiftSuccess, startEmpShiftFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(startEmpShiftFail(error));
    showToast("error", "Shift", error);
  }
}

function* EmpfetchFolders({ payload: data }) {
  try {
    const response = yield call(onEmpFecthFolders, data);
    if (response.status) {
      yield put(empGetFoldersSuccess(response));
    } else {
      yield put(empGetFoldersFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(empGetFoldersFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* EmpfetchFiles({ payload: data }) {
  try {
    const response = yield call(onEmpFecthFiles, data);
    if (response.status) {
      yield put(empGetFoldersFileSuccess(response));
    } else {
      yield put(empGetFoldersFileFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(empGetFoldersFileFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* EmppostAddFile({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onEmpAddingFileToFolder, data);
    yield call(responseHandler, "Private Folder", response, empAddFileToFolderSuccess, empAddFileToFolderFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(empAddFileToFolderFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* LOG_OUT_STAFF({ payload: data }) {
  try {
    const response = yield call(log_out_staff, data);
    localStorage.removeItem("uid");
    localStorage.removeItem("authUser");
    yield put(logout_staffSuccess(response));
  } catch (error) {
    yield put(logout_staffFail(error));
  }
}

function* Policy_For_Employee({ payload: data }) {
  try {
    const response = yield call(fetchPoliyForEmployee, data);
    yield put(getPolicyForEmployeeSuccess(response));
  } catch (error) {
    yield put(getPolicyForEmployeeFail(error));
  }
}

function* GET_note_by_id({ payload: data }) {
  try {
    const response = yield call(getProgressNotes, data);
    yield put(getNoteByIdSuccess(response));
  } catch (error) {
    yield put(getNoteByIdFail(error));
  }
}

function* update_staff_note({ payload: data }) {
  try {
    const response = yield call(updateStaffProgressNote, data);
    if (response.status) {
      yield put(updateStaffNoteSuccess(response));
      showToast("success", "Pregress note", response.message);
    } else {
      if (response.task_time_out) {
        showToast("info", "Time out", response.message);
        yield put(showModal(response));
      } else {
        showToast("warning", "Pregress note", response.message);
      }
    }
  } catch (error) {
    yield put(updateStaffNoteFail(error));
    showToast("error", "Pregress note", error);
  }
}

function* fetchStaffTaskd({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(staffTaskDetailsid, data);
    yield call(responseHandler, "Task Details", response, staffTaskidSuccess, staffTaskidFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(staffTaskidFail(error));
  }
}

function* Get_Incident_Form_questions({ payload: data }) {
  try {
    const response = yield call(incidentFormQuestions, data);
    yield put(getIncidentFormQuestionSuccess(response));
  } catch (error) {
    yield put(getIncidentFormQuestionFail(error));
    showToast("error", "Error", error);
  }
}

function* Get_My_Shifts({ payload: data }) {
  try {
    const response = yield call(fetchMyShifts, data);
    yield put(getMyShiftsSuccess(response));
  } catch (error) {
    yield put(getMyShiftsFail(error));
    showToast("error", "Error", error);
  }
}

function* Upload_Reqired_Docs({ payload: data }) {
  try {
    const response = yield call(uploadEmployeeReqDocs, data);
    yield put(uploadReqDocsSuccess(response));
  } catch (error) {
    yield put(uploadReqDocsFail(error));
    showToast("error", "Error", error);
  }
}

function* Get_Employee_Doc_List({ payload: data }) {
  try {
    const response = yield call(getDocumentsStatus, data);
    yield put(documentsStatusSuccess(response));
  } catch (error) {
    yield put(documentsStatusFail(error));
    showToast("error", "Error", error);
  }
}

function* Submit_Incident_Form({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(submitIncidentForm, data);
    yield call(responseHandler, "Incident Form", response, submitEmployeeIncidentFormSuccess, submitEmployeeIncidentFormFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(submitEmployeeIncidentFormFail(error));
    showToast("error", "Incident Form", error);
  }
}

function* Upload_Training_Cert({ payload: data }) {
  try {
    const response = yield call(uploadStaffCert, data);
    yield put(uploadTrainingCertDocsSuccess(response));
    if (response.status) showToast("success", "Uploading", response?.message);
  } catch (error) {
    yield put(uploadTrainingCertDocsFail(error));
    showToast("error", "Error", error);
  }
}

function* fetchEvents({ payload: data }) {
  try {
    const response = yield call(staffgetEvents, data);
    yield put(staffgetEventsSuccess(response));
  } catch (error) {
    yield put(staffgetEventsFail(error));
    showToast("error", "Error", error);
  }
}

function* GET_Participant_Details({ payload: event }) {
  try {
    const response = yield call(partDetailsgetStaff, event);
    yield put(getPartDetailSuccess(response));
  } catch (error) {
    yield put(getPartDetailFail(error));
    showToast("error", "Error", error);
  }
}

function* Get_prog_notes({ payload: event }) {
  try {
    const response = yield call(getProgNotes, event);
    if (response.status) {
      yield put(serviceProgressNoteSuccess(response.message));
      showToast("success", "Progress Note", response.message);
    } else {
      if (response.task_time_out) {
        showToast("info", "Time out", response.message);
        yield put(showModal(response));
      } else {
        yield put(serviceProgressNoteSuccess(response.message)); // called this function so the useEffect change it's State
        yield put(serviceProgressNoteFail(response.message));
        showToast("warning", "Progress Note", response.message);
      }
    }
  } catch (error) {
    yield put(serviceProgressNoteFail(error));
    showToast("error", "Progress Note", error);
  }
}

function* get_service_items({ payload: event }) {
  try {
    const response = yield call(getSerItem, event);
    yield put(getServiceItemDetailsSuccess(response));
  } catch (error) {
    yield put(getServiceItemDetailsFail(error));
    showToast("error", "Error", error);
  }
}

function* post_clockInTime({ payload: data }) {
  try {
    const response = yield call(postClockintime, data);
    yield put(postClockInTimeSuccess(response));
    showToast("success", "Clock In", response.message);
  } catch (error) {
    yield put(postClockInTimeFail(error));
    showToast("error", "Error", error);
  }
}

function* post_timings({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(postTimmingData, data);
    yield call(responseHandler, "Timing", response, postTimmingsSuccess, postTimmingsFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(postTimmingsFail(error));
    showToast("error", "Error", error);
  }
}

function* onConfirmJob({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onConfirmingJob, data);
    yield call(responseHandler, "Job Action", response, staffActionSuccess, staffActionFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(staffActionFail(error));
    showToast("error", "Error", error);
  }
}

function* Post_incident_report({ payload: data }) {
  try {
    const response = yield call(postIncidentReport, data);
    yield put(submitIncidentReportSuccess(response));
    showToast("success", "Incident Report", response.message);
  } catch (error) {
    yield put(submitIncidentReportFail(error));
    showToast("error", "Incident Report", error);
  }
}

function* Confirm_Training_Terms({ payload: data }) {
  try {
    const response = yield call(trainingTermsConfirmation, data);
    yield put(confirmTrainingTermsSuccess(response));
    showToast("success", "Trainings", response.message);
  } catch (error) {
    yield put(confirmTrainingTermsFail(error));
    showToast("error", "Trainings", error);
  }
}

function* Post_Task_Time_out({ payload: data }) {
  try {
    const response = yield call(setTaskTimeoutouted, data);
    yield put(setTaskTimeoutSuccess(response));
  } catch (error) {
    yield put(setTaskTimeoutFail(error));
  }
}

function* Approve_Submition({ payload: { data, history } }) {
  try {
    const response = yield call(approveSubmit, data);
    yield put(submitApproveSuccess(response));
    showToast("success", "Approval", response.message);
    history.push("/staff-view");
  } catch (error) {
    yield put(submitApproveFail(error));
    showToast("error", "Approval", error);
  }
}

function* Notes_by_Admin({ payload: { data, history, redirectUrl } }) {
  try {
    // const response = yield call(progressNotesByAdmin, data);
    history.push(`/details/${data?.id}?redirect=${redirectUrl}`);
    // if (response.status) {
    //   yield put(notesByAdminSuccess(response));
    // if (response?.data?.task_data?.staff_token) {
    //   localStorage.setItem('uid', JSON.stringify(response.data?.task_data?.staff_token));
    //   setTimeout(() => {
    // }, 100);
    // }
    // }
  } catch (error) {
    yield put(notesByAdminFail(error));
    showToast("error", "User Loggin", error);
  }
}

function* Get_Employee_Training({ payload: data }) {
  try {
    const response = yield call(getStaffTraining, data);
    yield put(getEmployeeTrainingsSuccess(response));
  } catch (error) {
    yield put(getEmployeeTrainingsFail(error));
    showToast("error", "Employee Trainings", error);
  }
}

function* Employee_Profile({ payload: { data } }) {
  try {
    const response = yield call(employeeProfile, data);
    yield put(getEmployeeProfileSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(getEmployeeProfileFail(error));
    showToast("error", "Error", error);
  }
}

function* Employee_Attachments({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(sendAttachedFileByEmployee, data);
    yield call(responseHandler, "Attachments", response, sendAttachmentsByEmployeeSuccess, sendAttachmentsByEmployeeFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(sendAttachmentsByEmployeeFail(error));
    showToast("error", "Attachments", error);
  }
}

function* Download_BTN_HIT({ payload: data }) {
  try {
    const response = yield call(clickedOnDownlaod, data);
    yield put(hitDownloadSuccess(response));
  } catch (error) {
    yield put(hitDownloadFail(error));
    showToast("error", "Downloading", error);
  }
}

function* onSaveNoteByUser({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSavingNoteByUser, data);
    yield call(responseHandler, "Saving Progress Notes", response, saveProgressNoteByUserSuccess, saveProgressNoteByUserFail, onSuccess, onError);
  } catch (error) {
    onError();
    showToast("error", "Saving Progress Notes", error);
    yield put(saveProgressNoteByUserFail(error));
  }
}

function* onGetTimeSheet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingSupportWorkerTimeSheet, data);
    yield call(responseHandler, "Time sheet", response, getSupportWorkerTimeSheetSuccess, getSupportWorkerTimeSheetFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    showToast("error", "Time sheet", error);
    yield put(getSupportWorkerTimeSheetFail(error));
  }
}

function* onSubmitComment({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSubmittingComment, data);
    yield call(responseHandler, "Time sheet", response, submitTimeSheetCommentSuccess, submitTimeSheetCommentFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    showToast("error", "Time sheet", error);
    yield put(submitTimeSheetCommentFail(error));
  }
}

function* onAwayParticipant({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(awayPariticipant, data);
    yield call(responseHandler, "Away Pariticipant", response, awayPariticipantSuccess, awayPariticipantError, onSuccess, onError, false);
  } catch (error) {
    onError();
    showToast("error", "Away Pariticipantt", error);
    yield put(awayPariticipantError(error));
  }
}

function* onUpdateVehicleDetails({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingVehicleDetails, data);
    yield call(responseHandler, "Vehicle Details", response, updateVehicleDetailsSuccess, updateVehicleDetailsFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    showToast("error", "Vehicle Details", error);
    yield put(updateVehicleDetailsFail(error));
  }
}

function* onSubmitComplaintForm({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSubmittingComplaintList, data);
    yield call(responseHandler, "Feedback Form", response, getEmployeeComplaintFormSuccess, getEmployeeComplaintFormError, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(getEmployeeComplaintFormError(error));
    showToast("error", "Feedback Form", error);
  }
}

function* StaffViewSaga() {
  yield takeEvery(UPDATE_VEHICLE_DETAILS_EMPLOYEE, onUpdateVehicleDetails);
  yield takeEvery(SUBMIT_TIMESHEET_COMMENT, onSubmitComment);
  yield takeEvery(GET_SUPPORT_WORKER_TIME_SHEETS, onGetTimeSheet);
  yield takeEvery(REFINE_TEXT, onRefineNotesText);
  yield takeEvery(SAVE_PROGRESS_NOTE, onSaveNoteByUser);
  yield takeEvery(SUBMIT_HAZARD_REPORT, onSubmitHazard);
  yield takeEvery(STAFF_GET_EVENTS, fetchEvents);
  yield takeEvery(SET_TASK_TIMEOUT, Post_Task_Time_out);
  yield takeEvery(STAFF_PART_DETAILS, GET_Participant_Details);
  yield takeEvery(SERVICE_PROGRESS_NOTE, Get_prog_notes);
  yield takeEvery(SERVICE_ITEM_DETAILS, get_service_items);
  yield takeEvery(POST_CLOCK_IN_TIME, post_clockInTime);
  yield takeEvery(STAFF_TASK_ID, fetchStaffTaskd);
  yield takeEvery(LOGOUT_STAFF, LOG_OUT_STAFF);
  yield takeEvery(GET_NOTE_BY_ID, GET_note_by_id);
  yield takeEvery(UPDATE_STAFF_PRO_NOTE, update_staff_note);
  yield takeEvery(POST_TIMMINGS, post_timings);
  yield takeEvery(STAFF_ACTION, onConfirmJob);
  yield takeEvery(SUBMIT_INICIDENT_REPORT, Post_incident_report);
  yield takeEvery(SUBMITION_APPROVAL, Approve_Submition);
  yield takeEvery(NOTES_BY_ADMIN, Notes_by_Admin);
  yield takeEvery(GET_EMPLOYEE_PROFILE_DETAILS, Employee_Profile);
  yield takeEvery(SEND_ATTACHMENTS_BY_EMPLOYEE, Employee_Attachments);
  yield takeEvery(UPLOAD_REQ_DOCS, Upload_Reqired_Docs);
  yield takeEvery(UPLOAD_STAFF_CERTIFICATE_DOCS, Upload_Training_Cert);
  yield takeEvery(GET_DOCUMENTS_STATUS_LIST, Get_Employee_Doc_List);
  yield takeEvery(GET_TRAININGS_STAFF, Get_Employee_Training);
  yield takeEvery(GET_INICIDENT_FORM_QUESTIONS, Get_Incident_Form_questions);
  yield takeEvery(SUBMIT_INCIDENT_FORM_EMPLOYEE, Submit_Incident_Form);
  yield takeEvery(GET_POLICY_FOR_EMPLOYEE, Policy_For_Employee);
  yield takeEvery(CONFIRM_TRAINING_TERMS, Confirm_Training_Terms);
  yield takeEvery(HIT_DOWNLOAD, Download_BTN_HIT);
  yield takeEvery(GET_MY_SHIFTS, Get_My_Shifts);
  yield takeEvery(EMP_GET_FOLDERS, EmpfetchFolders);
  yield takeEvery(EMP_GET_FOLDER_FILES, EmpfetchFiles);
  yield takeEvery(EMP_ADD_FILE_TO_FOLDER, EmppostAddFile);
  yield takeEvery(START_EMP_SHIFT, onEmpStartShift);
  yield takeEvery(END_EMP_SHIFT, onEmpEndShift);
  yield takeEvery(EMP_AVAILABILITY, onEmpGetAvailability);
  yield takeEvery(EMP_ADD_AVAILABILITY, onEmpAddOpenShift);
  yield takeEvery(EMP_UPDATE_AVAILABILITY, onEmpUpdateOpenShift);
  yield takeEvery(EMP_GET_OPEN_SHIFTS, onGettingOpenShift);
  yield takeEvery(REQUEST_OPEN_SHIFT, onRequestOpenShift);
  yield takeEvery(CANCEL_OPEN_SHIFT, onCancelOpenShift);
  yield takeEvery(GET_REQUESTED_OPEN_SHIFTS, onGetRequestedOpenShift);
  yield takeEvery(USER_ACCOUNTS_LIST, onGetAccountList);
  yield takeEvery(SWITCH_ACCOUNT, onSwitchAccount);
  yield takeEvery(REMOVE_EMP_SWITCH_ACCOUNT, onRemoveSwitchAccount);
  yield takeEvery(GET_MEDICATION_DETAILS, onGetMedication);
  yield takeEvery(SUBMIT_MED_REPORT, onSubmitMedReport);
  yield takeEvery(GET_EMP_MEDICINE_LIST, onGetEmpMedicines);
  yield takeEvery(GET_TODAYS_MEDICATION, onGetTodaysMedications);
  yield takeEvery(EMP_SUBMIT_MEDICATION, onSubmitMedication);
  yield takeEvery(EMP_MEDICATION_PRN, onGetMedPRN);
  yield takeEvery(AWAY_PARTICIPANT, onAwayParticipant);
  yield takeEvery(SUBMIT_EMPLOYEE_COMPLAINT_FORM, onSubmitComplaintForm);
}

export default StaffViewSaga;
